import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {WinterHoard} from "./WinterHoard";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinterHoardSoundConfig} from "./WinterHoardSoundConfig";
import {WinterHoardGameModuleConfig} from "./WinterHoardGameModuleConfig";
import {IWinterHoardGameData} from "./server/data/IWinterHoardServerData";
import {WinterHoardGameMode} from "./gamemode/WinterHoardGameMode";

export class BuffaloHunterPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "WinterHoard",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "Buffalo"},
            bonusGame: {
                header: () => WinterHoard.api.translations.translate("Pick Bonus Mode"),
                options: [
                    {name: "BUFFALO HORDE", id: 1, image: "choice1.png"},
                    {name: "PRAIRIE MULTIPLIER", id: 2, image: "choice2.png"},
                ],
                type: ASBonusPickOptions.PICK_MODE,
                pickNeededForModes: ["FREESPIN_PICK"],
                pickNeededForBuyFeatures: ["FREESPIN"]
            },
            getParsedData: (response: IWinterHoardGameData, bet: number, prevResponse: IWinterHoardGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: parseFloat(response.accumulatedRoundWin),
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: true,
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(WinterHoardSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(WinterHoardSoundConfig.instance.AS_WIN_BIG);
        }
    }

    private isBigWin(response: IWinterHoardGameData): boolean {
        const win = parseFloat(response.totalSpinWinnings);
        const playedBetValue = parseFloat(response.playedBetValue);
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice: number = WinterHoardGameModuleConfig.featurePrice.getBuyFeaturePrice(playedBetValue, response.wasFeatureBuy)
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: IWinterHoardGameData, bet: number, prevData: IWinterHoardGameData): number {
        return parseFloat(response.totalSpinWinnings);
    }

    private getFeatureName(response: IWinterHoardGameData): string {
        if (response.nextMode === "FREESPIN_PICK") {
            return "Pick Bonus Mode";
        }
        if (response.mode === WinterHoardGameMode.FREESPIN_COMBINED || response.nextMode === WinterHoardGameMode.FREESPIN_COMBINED) {
            return "STAMPEDE SUPER BONUS";
        }
        if (response.mode === WinterHoardGameMode.FREESPIN_TRANSFORM || response.nextMode === WinterHoardGameMode.FREESPIN_TRANSFORM) {
            return "BUFFALO HORDE";
        }
        if (response.mode === WinterHoardGameMode.FREESPIN_MULTIPLIER || response.nextMode === WinterHoardGameMode.FREESPIN_MULTIPLIER) {
            return "PRAIRIE MULTIPLIER";
        }

        return "";
    }

    private isFreeSpinTriggered(response: IWinterHoardGameData): boolean {
        return response.freespinTriggeredThisSpin ? response.freespinTriggeredThisSpin : false;
    }

    private isRoundComplete(response: IWinterHoardGameData): boolean {
        return ([WinterHoardGameMode.NORMAL, WinterHoardGameMode.FREESPIN, WinterHoardGameMode.FREESPIN_MULTIPLIER, WinterHoardGameMode.FREESPIN_COMBINED, WinterHoardGameMode.FREESPIN_TRANSFORM].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IWinterHoardGameData): boolean {
        return ((response.mode === WinterHoardGameMode.FREESPIN) || (response.mode === WinterHoardGameMode.FREESPIN_MULTIPLIER) || (response.mode === WinterHoardGameMode.FREESPIN_COMBINED) || (response.mode === WinterHoardGameMode.FREESPIN_TRANSFORM)) && response.nextMode === WinterHoardGameMode.NORMAL;
    }

}